import { render } from "./Areas.vue?vue&type=template&id=39b87d26"
import script from "./Areas.vue?vue&type=script&lang=js"
export * from "./Areas.vue?vue&type=script&lang=js"
script.render = render

export default script